module.exports = __webpack_public_path__ + "static/media/challenge1.ce9a95ef.png";